<div class="flex h-screen w-full bg-[#fdfdff] overflow-hidden">
  <app-sidebar [(drawerOpen)]="drawerOpen"></app-sidebar>

  <div class="flex-1 flex flex-col min-w-0 min-h-svh">
    <app-header (toggleSidebar)="drawerOpen = !drawerOpen"></app-header>

    <main class="flex-1 overflow-y-auto overflow-x-hidden scroll-smooth">
      <div class="mx-auto min-h-full flex flex-col p-4">
        <div class="flex-1 flex flex-col">
          <router-outlet></router-outlet>
        </div>
      </div>
<!--      <app-footer></app-footer>-->
    </main>
  </div>
</div>
